import script from "./install-statistics-export.vue?vue&type=script&setup=true&lang=ts"
export * from "./install-statistics-export.vue?vue&type=script&setup=true&lang=ts"

import "./install-statistics-export.vue?vue&type=style&index=0&id=36d48c46&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d48c46"]])

export default __exports__